import React, { Component, Fragment } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationPaths } from './api-authorization/ApiAuthorizationConstants';
import AuthFunctions from './services/AuthService';
import AdminFunctions from './admin/AdminFunctions';
import Session from './auth/Session';
//import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';

export class SideBar extends Component {
    static displayName = SideBar.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            isAuthenticated: false,
            isAdmin: false,
            userName: null
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }
    componentDidMount() {
        //this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    componentWillUnmount() {
        //authService.unsubscribe(this._subscription);
    }

    async populateState() {
        //const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        const isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        var isAdmin = false;
        var isWrite = false;
        if (isAuthenticated) {
            isAdmin = await AdminFunctions.isAdminAsync();
            isWrite = await AdminFunctions.isRole("Write");
        }
        const userName = Session.getUserName();
        this.setState({
            isAuthenticated,
            userName: userName,
            isAdmin: isAdmin || isWrite
        });
    }
    //render() {
    //    return (
    //        <header>
    //            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
    //                <Container>
    //                    <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
    //                        <ul className="navbar-nav flex-grow">
    //                            <li>Lease Search</li>
    //                        </ul>
    //                    </Collapse>
    //                </Container>
    //            </Navbar>
    //        </header>
    //    );
    //}
    render() {
        const { isAuthenticated, userName } = this.state;
        if (!isAuthenticated) {
            const registerPath = `${ApplicationPaths.BaseIdentityRegisterPath}`;
            //const loginPath = `${ApplicationPaths.Login}`;
            const loginPath = `/login`;
            return this.anonymousView(registerPath, loginPath);
        } else {
            const profilePath = `${ApplicationPaths.Profile}`;
            //const logoutPath = { pathname: `${ApplicationPaths.LogOut}`, state: { local: true } };
            const logoutPath = { pathname: `/logout`, state: { local: true } };
            const AcctDetails = { pathname: `/User/AcctDetails`, state: { local: true } };
            var currentUrl = window.location.href;
            if (currentUrl.includes("/Comps/")) {
                return this.compsView(userName, profilePath, logoutPath, AcctDetails);
            } else {
                return this.authenticatedView(userName, profilePath, logoutPath, AcctDetails);
            }
            
        }
    }
    compsView(userName, profilePath, logoutPath, AcctDetails) {
        return (<header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white mb-3 g-warm-gray-bg g-warm-gray-c sideBar" light location={this.props.location}>
                <Container style={{ 'marginTop': '45px' }}>
                    <Collapse className="d-sm-inline-flex flex-sm-row-reverse " isOpen={!this.state.collapsed} navbar>
                        <ul className="flex-grow">
                            <li>
                                Office Lease Comps 
                                <ul >
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Comps/CompSearch?compType=1'
                                        >
                                            Search Comps
                                        </NavLink>
                                    </li>
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Comps/CompsAdd?compType=1'
                                        >
                                            Add Comp
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>

                            <li>
                                Office Sale Comps
                                <ul >
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Comps/CompSearch?compType=2'
                                        >
                                            Search Comps
                                        </NavLink>
                                    </li>
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Comps/CompsAdd?compType=2'
                                        >
                                            Add Comp
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>

                            <li>
                                Ind. Lease Comps
                                <ul >
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Comps/CompSearch?compType=3'
                                        >
                                            Search Comps
                                        </NavLink>
                                    </li>
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Comps/CompsAdd?compType=3'
                                        >
                                            Add Comp
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>

                            <li>
                                Ind. Sale Comps
                                <ul >
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Comps/CompSearch?compType=4'
                                        >
                                            Search Comps
                                        </NavLink>
                                    </li>
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Comps/CompsAdd?compType=4'
                                        >
                                            Add Comp
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>

                            <li>
                                Retail Lease Comps
                                <ul >
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Comps/CompSearch?compType=5'
                                        >
                                            Search Comps
                                        </NavLink>
                                    </li>
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Comps/CompsAdd?compType=5'
                                        >
                                            Add Comp
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>

                            <li>
                                Retail Sale Comps
                                <ul >
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Comps/CompSearch?compType=6'
                                        >
                                            Search Comps
                                        </NavLink>
                                    </li>
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Comps/CompsAdd?compType=6'
                                        >
                                            Add Comp
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>

                            <li>
                                Land Sale Comps
                                <ul >
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Comps/CompSearch?compType=7'
                                        >
                                            Search Comps
                                        </NavLink>
                                    </li>
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Comps/CompsAdd?compType=7'
                                        >
                                            Add Comp
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>

                            <li>
                                Multi-Family Comps
                                <ul >
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Comps/CompSearch?compType=8'
                                        >
                                            Search Comps
                                        </NavLink>
                                    </li>
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Comps/CompsAdd?compType=8'
                                        >
                                            Add Comp
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>
                            <li hidden={!this.state.isAdmin ? true : false}>
                                <NavLink className="nav-button g-orange-a big-a"
                                    tag={Link}
                                    to='/admin/Clients'
                                    hidden={!this.state.isAdmin ? true : false}
                                >
                                    Panoramic Home
                                </NavLink>
                            </li>
                            
                            <li className="compsLoginText">
                                Username: {userName}
                                <ul>
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink tag={Link} className="nav-button g-orange-a big-a" to={logoutPath}>Logout</NavLink>
                                    </li>
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink tag={Link} className="nav-button g-orange-a big-a" to={AcctDetails}>Change Password</NavLink>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </Collapse>
                </Container>
            </Navbar>
        </header>);

    }
    authenticatedView(userName, profilePath, logoutPath, AcctDetails) {
        return (<header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white mb-3 g-warm-gray-bg g-warm-gray-c sideBar" light location={this.props.location}>
                <Container style={{ 'marginTop': '45px' }}>
                    <Collapse className="d-sm-inline-flex flex-sm-row-reverse " isOpen={!this.state.collapsed} navbar>
                        <ul className="flex-grow">
                            <li>
                                Lease Management
                                <ul >
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Lease/LeaseSearch'
                                        >
                                            Search
                                        </NavLink>
                                    </li>
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Lease/ActiveLeases'
                                        >
                                            Active Leases
                                        </NavLink>
                                    </li>
                                    <li style={{ listStyle: 'circle' }} hidden={!this.state.isAdmin ? true : false}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Lease/AddLease'
                                            hidden={!this.state.isAdmin ? true : false}
                                        >
                                            Add Lease
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Lease Overview
                                <ul>
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/Lease/LeaseDashboard'
                                        >
                                            Dashboard
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>
                            <li hidden={!this.state.isAdmin ? true : false}>
                                        <NavLink className="nav-button g-orange-a big-a"
                                            tag={Link}
                                            to='/admin/Clients'
                                            hidden={!this.state.isAdmin ? true : false}
                                        >
                                            Panoramic Home
                                        </NavLink>
                                    </li>
                            <li className="loginText">
                                Username: {userName}
                                <ul>
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink tag={Link} className="nav-button g-orange-a big-a" to={logoutPath}>Logout</NavLink>
                                    </li>
                                    <li style={{ listStyle: 'circle' }}>
                                        <NavLink tag={Link} className="nav-button g-orange-a big-a" to={AcctDetails}>Change Password</NavLink>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </Collapse>
                </Container>
            </Navbar>
        </header>);

    }

    anonymousView(registerPath, loginPath) {
        return (<header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light location={this.props.location}>
                <Container>
                    <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                        <ul className="navbar-nav flex-grow">
                        </ul>
                    </Collapse>
                </Container>
            </Navbar>
        </header>);
    }
}
